module.exports = __webpack_public_path__ + "static/New_Hero_Bold-10d20eac777ea722632346914fa5f4dc.otf";